import { render, staticRenderFns } from "./jzxxDialog.vue?vue&type=template&id=3bb97227&"
import script from "./jzxxDialog.vue?vue&type=script&lang=js&"
export * from "./jzxxDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports